import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useSearchContext } from "../context/SearchContext";
import { useDemoMode } from "../hooks/useDemoMode";
import { SearchForm } from "../components/SearchForm";
import { ResultsList } from "../components/ResultsList";

export function SearchPage() {
  const [params] = useSearchParams();
  const { state, dispatch } = useSearchContext();
  const demo = useDemoMode();

  // Prefill the artist from a ?artist= query param (footer/home links land here).
  const artistParam = params.get("artist");
  useEffect(() => {
    if (artistParam && artistParam !== state.artist) {
      dispatch({ type: "SET_ARTIST", artist: artistParam });
    }
    // Only react to the URL param changing, not every keystroke.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [artistParam]);

  return (
    <div className="mx-auto max-w-3xl px-4 py-8">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-slate-900">Find concert deals</h1>
        <p className="mt-1 text-sm text-slate-500">
          Search an artist and your home airport to compare every tour stop by
          total trip cost.
        </p>
      </div>

      {demo && (
        <div className="mb-4 rounded-lg border border-amber-200 bg-amber-50 px-4 py-2.5 text-sm text-amber-800">
          <span className="font-semibold">Demo mode</span> — showing sample data
          for 3 artists (Taylor Swift, Kendrick Lamar, Olivia Rodrigo). Connect
          the backend with API keys for live prices.
        </div>
      )}

      <div className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
        <SearchForm ctaLabel="Find deals" />
      </div>

      <div className="mt-8">
        <ResultsList />
      </div>
    </div>
  );
}
